import { render, staticRenderFns } from "./templateComponet.vue?vue&type=template&id=4f3e720e&"
import script from "./templateComponet.vue?vue&type=script&lang=js&"
export * from "./templateComponet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports